/**
 * communicationPrefs.js — öğrenci iletişim izinleri (KVKK / 6563 sayılı Kanun)
 * için paylaşılan varsayılanlar ve normalize mantığı.
 *
 * NotificationPreferencesSection.js bu modülü kullanır. Mantık kasıtlı olarak
 * ayrı bir dosyada tutuluyor: component'i render etmeden (bu depoda bazı
 * render-tabanlı testler @testing-library/react eksikliğinden çalışmıyor —
 * bkz. __tests__/utils/communicationPrefs.test.js üstündeki not) saf JS
 * testleriyle doğrulanabilsin.
 *
 * Spec (proje-yoneticisi görev talimatı — backend PLANLANAN şeması):
 *   users.communication_prefs = {
 *     service_email: bool, service_whatsapp: bool,
 *     commercial_email: bool, commercial_whatsapp: bool, updated_at: iso
 *   }
 *   Varsayılan: hizmet kanalları AÇIK, ticari kanallar KAPALI.
 */

export const DEFAULT_COMMUNICATION_PREFS = {
  service_email: true,
  service_whatsapp: true,
  commercial_email: false,
  commercial_whatsapp: false,
};

/**
 * Backend'den gelen (kısmi/eksik/null olabilen) bir objeyi güvenli
 * varsayılanlarla tamamlar. `??` kullanılır (`||` DEĞİL) — açıkça `false`
 * gönderilen bir alan varsayılana geri düşmemeli.
 */
export function normalizeCommunicationPrefs(data) {
  return {
    service_email: data?.service_email ?? DEFAULT_COMMUNICATION_PREFS.service_email,
    service_whatsapp: data?.service_whatsapp ?? DEFAULT_COMMUNICATION_PREFS.service_whatsapp,
    commercial_email: data?.commercial_email ?? DEFAULT_COMMUNICATION_PREFS.commercial_email,
    commercial_whatsapp: data?.commercial_whatsapp ?? DEFAULT_COMMUNICATION_PREFS.commercial_whatsapp,
  };
}
